<template>
  <div class="body_right">
    <div class="right_container">
      <div class="right_title">
        <div class="title">직원정보 수정</div>
        <div class="description">
          직원정보 수정합니다. <span class="text_red">(* 필수항목)</span>
        </div>

        <article class="right_body">
          <div class="tbl_search tbl_info">
            <div class="part_title"></div>
            <table>
              <colgroup>
                <col style="width: 18%" class="col_width26" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>아이디<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="text"
                        class="w_250"
                        placeholder="아이디를 입력해주세요"
                        v-model="inputData.userId"
                        ref="userId"
                        disabled
                      />
                      <div v-if="isDuplicate" class="validation text_red">
                        이미 존재하는 ID 입니다.
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>비밀번호<span class="text_red">*</span></th>
                  <td>
                    <input
                      type="password"
                      class="w_250"
                      placeholder="비밀번호를 입력해주세요"
                      v-model="inputData.userPw"
                      ref="userPw"
                    />
                  </td>
                </tr>
                <tr>
                  <th>이름<span class="text_red">*</span></th>
                  <td>
                    <input
                      type="text"
                      class="w_250"
                      placeholder="이름을 입력해주세요"
                      v-model="inputData.userName"
                      ref="userName"
                    />
                  </td>
                </tr>
                <tr>
                  <th>성별<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <button
                        type="button"
                        :class="{ on: inputData.selectedGender === 'M' }"
                        @click="selectGender('M')"
                        ref="selectedGender"
                      >
                        남
                      </button>
                      <button
                        type="button"
                        :class="{ on: inputData.selectedGender === 'F' }"
                        @click="selectGender('F')"
                        ref="selectedGender"
                      >
                        여
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>생년월일<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="date"
                        class="w_250"
                        v-model="inputData.selectedBirthDate"
                        ref="selectedBirthDate"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>주민번호<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="text"
                        class="w_120"
                        maxlength="6"
                        v-model="inputData.userSocialNum1"
                        ref="userSocialNum1"
                        @input="
                          inputData.userSocialNum1 =
                            inputData.userSocialNum1.replace(/\D/g, '')
                        "
                      />
                      -
                      <input
                        type="text"
                        class="w_120"
                        maxlength="7"
                        v-model="inputData.userSocialNum2"
                        ref="userSocialNum2"
                        @input="
                          inputData.userSocialNum2 =
                            inputData.userSocialNum2.replace(/\D/g, '')
                        "
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>사내메일<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td mobile_number">
                      <input
                        type="text"
                        class="w_120"
                        v-model="inputData.userCompanyEmail"
                        ref="userCompanyEmail"
                      />
                      @ mizecompany.co.kr
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>휴대폰번호<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td mobile_number">
                      <select v-model="inputData.userPhone1">
                        <option value="010">010</option>
                        <option value="011">011</option>
                        <option value="016">016</option>
                        <option value="017">017</option>
                        <option value="018">018</option>
                        <option value="019">019</option>
                      </select>
                      -
                      <input
                        type="text"
                        class="w_55"
                        maxlength="4"
                        v-model="inputData.userPhone2"
                        ref="userPhone2"
                        @input="
                          inputData.userPhone2 = inputData.userPhone2.replace(
                            /\D/g,
                            '',
                          )
                        "
                      />
                      -
                      <input
                        type="text"
                        class="w_55"
                        maxlength="4"
                        v-model="inputData.userPhone3"
                        ref="userPhone3"
                        @input="
                          inputData.userPhone3 = inputData.userPhone3.replace(
                            /\D/g,
                            '',
                          )
                        "
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>모드변환 권한<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <button
                        type="button"
                        :class="{ on: inputData.selectedModeAuth === 'A' }"
                        @click="selectModeAuth('A')"
                        ref="selectedModeAuth"
                      >
                        전체
                      </button>
                      <button
                        type="button"
                        :class="{ on: inputData.selectedModeAuth === 'M' }"
                        @click="selectModeAuth('M')"
                        ref="selectedModeAuth"
                      >
                        마이즈클라우드
                      </button>
                      <button
                        type="button"
                        :class="{ on: inputData.selectedModeAuth === 'C' }"
                        @click="selectModeAuth('C')"
                        ref="selectedModeAuth"
                      >
                        외주업체
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>메뉴 권한<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <button @click="showMenu = !showMenu" ref="showMenu">
                        {{ showMenu ? "닫기" : "선택" }}
                      </button>
                      <div v-show="showMenu" class="menu-container">
                        <div class="button-group">
                          <button @click="selectAllMenus">전체 선택</button>
                          <button @click="unselectAllMenus">전체 해제</button>
                        </div>
                        <div
                          v-for="(menu, index) in menuList"
                          :key="index"
                          class="menu-group"
                        >
                          <div class="menu-header">
                            <label>
                              <input
                                type="checkbox"
                                v-model="menu.checked"
                                @change="toggleTopMenu(menu)"
                              />
                              <strong>{{ menu.menuName }}</strong>
                            </label>
                          </div>
                          <div
                            class="menu-items"
                            v-if="menu.subLeftMenu?.length"
                          >
                            <label
                              v-for="(sub, subIndex) in menu.subLeftMenu"
                              :key="subIndex"
                              class="submenu-label"
                            >
                              <input
                                type="checkbox"
                                v-model="sub.checked"
                                @change="toggleLeftMenu(menu)"
                              />
                              {{ sub.menuName }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>사번<span class="text_red">*</span></th>
                  <td>
                    <input
                      type="text"
                      class="w_250"
                      placeholder="사번을 입력해주세요"
                      v-model="inputData.userNo"
                      ref="userNo"
                    />
                  </td>
                </tr>
                <tr>
                  <th>소속<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="text"
                        class="w_300"
                        placeholder="소속을 선택해주세요"
                        v-model="deptName"
                        ref="deptName"
                        disabled
                      />
                      <button @click="showDeptPopup = true" ref="showDeptPopup">
                        선택
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th ref="thPosition">직책<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <button
                        v-for="(position, index) in positionList"
                        :key="index"
                        type="button"
                        :class="{
                          on: inputData.selectedPosition === position.position,
                        }"
                        @click="selectPosition(position.position)"
                      >
                        {{ position.position }}
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>재직 상태<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <button
                        type="button"
                        :class="{ on: inputData.selectedUserStatus === 'A' }"
                        @click="selectUserStatus('A')"
                        ref="selectedUserStatus"
                      >
                        재직
                      </button>
                      <button
                        type="button"
                        :class="{ on: inputData.selectedUserStatus === 'I' }"
                        @click="selectUserStatus('I')"
                        ref="selectedUserStatus"
                      >
                        인턴
                      </button>
                      <button
                        type="button"
                        :class="{ on: inputData.selectedUserStatus === 'L' }"
                        @click="selectUserStatus('L')"
                        ref="selectedUserStatus"
                      >
                        휴직
                      </button>
                      <button
                        type="button"
                        :class="{ on: inputData.selectedUserStatus === 'P' }"
                        @click="selectUserStatus('P')"
                        ref="selectedUserStatus"
                      >
                        수습
                      </button>
                      <button
                        type="button"
                        :class="{ on: inputData.selectedUserStatus === 'R' }"
                        @click="selectUserStatus('R')"
                        ref="selectedUserStatus"
                      >
                        퇴직
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th ref="thPosition">
                    급여은행<span class="text_red">*</span>
                  </th>
                  <td>
                    <div class="inner_td">
                      <button
                        v-for="(bank, index) in bankList"
                        :key="index"
                        type="button"
                        :class="{ on: inputData.selectedBank === bank.bankId }"
                        @click="selectBank(bank.bankId)"
                      >
                        {{ bank.bankName }}
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>급여계좌<span class="text_red">*</span></th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="text"
                        class="w_250"
                        placeholder="급여계좌를 '-' 포함하여 입력해주세요."
                        v-model="inputData.userBankNum"
                        ref="userBankNum"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>주소</th>
                  <td class="td_address">
                    <div>
                      <input
                        type="text"
                        class="w_150"
                        placeholder="우편번호"
                        v-model="userZipCode"
                        ref="userZipCode"
                        readonly
                      />
                      <button
                        type="button"
                        class="keep"
                        @click="openPostcodePopup"
                      >
                        주소찾기
                      </button>
                    </div>
                    <input
                      type="text"
                      class="w_250"
                      placeholder="주소"
                      v-model="userAddr1"
                      ref="userAddr1"
                    />
                    <input
                      type="text"
                      class="w_250"
                      placeholder="상세주소"
                      v-model="userAddr2"
                      ref="userAddr2"
                    />
                  </td>
                </tr>
                <tr>
                  <th>개인메일</th>
                  <td>
                    <div class="inner_td mobile_number">
                      <input
                        type="text"
                        class="w_120"
                        v-model="userEmail"
                        ref="userEmail"
                      />
                      @

                      <button
                        type="button"
                        :class="{ on: selectedEmailAddr === 'naver.com' }"
                        @click="selectEmailAddr('naver.com')"
                        ref="selectedEmailAddr"
                      >
                        naver.com
                      </button>
                      <button
                        type="button"
                        :class="{ on: selectedEmailAddr === 'daum.net' }"
                        @click="selectEmailAddr('daum.net')"
                        ref="selectedEmailAddr"
                      >
                        daum.net
                      </button>
                      <button
                        type="button"
                        :class="{ on: selectedEmailAddr === 'nate.com' }"
                        @click="selectEmailAddr('nate.com')"
                        ref="selectedEmailAddr"
                      >
                        nate.com
                      </button>
                      <button
                        type="button"
                        :class="{ on: selectedEmailAddr === 'hanmail.net' }"
                        @click="selectEmailAddr('hanmail.net')"
                        ref="selectedEmailAddr"
                      >
                        hanmail.net
                      </button>
                      <button
                        type="button"
                        :class="{ on: selectedEmailAddr === 'gmail.com' }"
                        @click="selectEmailAddr('gmail.com')"
                        ref="selectedEmailAddr"
                      >
                        gmail.com
                      </button>
                      <button
                        type="button"
                        :class="{ on: selectedEmailAddr === '직접입력' }"
                        @click="selectEmailAddr('직접입력')"
                        ref="selectedEmailAddr"
                      >
                        직접입력
                      </button>
                      <input
                        v-if="selectedEmailAddr === '직접입력'"
                        type="text"
                        class="w_200"
                        v-model="customEmailAddr"
                        ref="customEmailAddr"
                        placeholder="이메일 주소를 입력해주세요"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>입사일</th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="date"
                        class="w_250"
                        v-model="selectedInDate"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>퇴사일</th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="date"
                        class="w_250"
                        v-model="selectedOutDate"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>1차 평가일</th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="date"
                        class="w_250"
                        v-model="selectedFirstEvalDate"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>2차 평가일</th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="date"
                        class="w_250"
                        v-model="selectedSecondEvalDate"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>수습 종료일</th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="date"
                        class="w_250"
                        v-model="selectedProbEndDate"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>연구직위</th>
                  <td>
                    <div class="inner_td">
                      <button
                        v-for="(
                          researchPosition, index
                        ) in researchPositionList"
                        :key="index"
                        type="button"
                        :class="{
                          on:
                            selectedResearchPosition ===
                            researchPosition.researchPositionCode,
                        }"
                        @click="
                          selectResearchPosition(
                            researchPosition.researchPositionCode,
                          )
                        "
                      >
                        {{ researchPosition.researchPositionName }}
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>연구직등록여부</th>
                  <td>
                    <div class="inner_td">
                      <button
                        type="button"
                        :class="{ on: selectedResearchPositionYn === 'Y' }"
                        @click="selectResearchPositionYn('Y')"
                      >
                        예
                      </button>
                      <button
                        type="button"
                        :class="{ on: selectedResearchPositionYn === 'N' }"
                        @click="selectResearchPositionYn('N')"
                      >
                        아니오
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>학력</th>
                  <td>
                    <div class="inner_td">
                      <button
                        v-for="(academic, index) in academicList"
                        :key="index"
                        type="button"
                        :class="{
                          on: selectedAcademic === academic.academicCode,
                        }"
                        @click="selectAcademic(academic.academicCode)"
                      >
                        {{ academic.academicName }}
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>전공명</th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="text"
                        class="w_250"
                        placeholder="전공명을 입력해주세요."
                        v-model="userMajorName"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>학위명</th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="text"
                        class="w_250"
                        placeholder="학위명을 입력해주세요."
                        v-model="userDegreeName"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>학위번호</th>
                  <td>
                    <div class="inner_td">
                      <input
                        type="text"
                        class="w_250"
                        placeholder="학위번호를 입력해주세요."
                        v-model="userDegreeNo"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>관련전공여부</th>
                  <td>
                    <div class="inner_td">
                      <button
                        type="button"
                        :class="{ on: selectedRelatedMajorMatchYn === 'Y' }"
                        @click="selectRelatedMajorMatchYn('Y')"
                      >
                        예
                      </button>
                      <button
                        type="button"
                        :class="{ on: selectedRelatedMajorMatchYn === 'N' }"
                        @click="selectRelatedMajorMatchYn('N')"
                      >
                        아니오
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>정보통신공사업 등급</th>
                  <td>
                    <div class="inner_td">
                      <button
                        v-for="(itGrade, index) in itGradeList"
                        :key="index"
                        type="button"
                        :class="{ on: selectedItGrade === itGrade.itGradeCode }"
                        @click="selectItGrade(itGrade.itGradeCode)"
                      >
                        {{ itGrade.itGradeName }}
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>관련자격증 첨부파일</th>
                  <td class="td_address">
                    <div class="file-upload-container">
                      <input
                        id="file-upload"
                        type="file"
                        @change="handleFileUpload"
                        multiple
                      />
                      <span v-if="allFiles.length > 0"
                        >총 선택 첨부파일 {{ allFiles.length }}개</span
                      >
                      <span v-else>
                        첨부파일 <span class="accent">없음</span></span
                      >
                    </div>
                    <ul>
                      <li v-for="(file, index) in allFiles" :key="index">
                        <button @click="downloadFile(file)">{{ file }}</button>
                        <button @click="removeFile(index)">삭제</button>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>사진</th>
                  <td class="td_address">
                    <div class="td_img">
                      <img
                        v-if="uploadedUserPhoto"
                        :src="`/employee_img/${encodeURIComponent(
                          uploadedUserPhoto,
                        )}`"
                      />
                      <img v-else src="@/images/no_img.png" alt="" />
                    </div>
                    <!-- 이미지 미리보기 -->
                    <div class="image-preview">
                      <img
                        v-if="userPhoto"
                        :src="userPhoto.url"
                        :alt="userPhoto.name"
                        class="preview-img"
                      />
                    </div>
                    <div>
                      <input
                        type="file"
                        class="w_250"
                        placeholder="선택된 파일 없음"
                        @change="handleImageChange"
                        ref="fileInput"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="btn_bottom_a">
            <button type="button" class="on" @click="checkChanges">수정</button>
            <button type="button" @click="goToUserList">취소</button>
          </div>
          <!-- 소속 선택 modal -->
          <div v-show="showDeptPopup" class="d_pop">
            <div class="d_pop_box">
              <div class="d_pop_top">
                <div class="title">소속 선택</div>
                <a href="###" @click="showDeptPopup = false">⨉</a>
              </div>
              <div class="d_pop_middle">
                <!-- 트리 구조 컴포넌트 -->
                <department-node
                  :nodes="departmentData"
                  @select-department="handleSelectDepartment"
                ></department-node>
              </div>
            </div>
          </div>
        </article>
      </div>
      <div style="margin-top: 10px"></div>
      <UserCommentSection :parameterId="this.id" :boardType="'직원'" />
    </div>
  </div>
  <!-- 변경된 이유 입력 모달  -->
  <ReasonModal
    v-if="isModalVisible3"
    @close-modal="closeModal"
    :isModalVisible3="isModalVisible3"
    :showModalForFields="showModalForFields"
    :currentFieldIndex="currentFieldIndex"
    @submit-reason="submitChangeReason"
  />
</template>

<script>
/* global daum */
import DepartmentNode from "@/layouts/DepartmentNode.vue";
import apiClient from "@/apiClient";
import { useToast } from "vue-toastification";
import imageCompression from "browser-image-compression";
import UserCommentSection from "@/components/comments/UserCommentSection.vue";
import ReasonModal from "@/components/comments/ReasonModal.vue"; // 모달 컴포넌트 import
import eventBus from "@/eventBus";

export default {
  name: "EmployeesView",
  setup() {
    const toast = useToast();
    return { toast };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    DepartmentNode,
    UserCommentSection,
    ReasonModal,
  },
  computed: {
    getUserId() {
      return this.$store.getters.getUserid;
    },
    getUserType() {
      return this.$store.getters.getUsertype;
    },
    getCompanyId() {
      return this.$store.getters.getCompanyid;
    },
    allFiles() {
      return [
        ...this.attachedFileList,
        ...this.uploadedFiles.map((file) => file.name),
      ];
    },
  },
  data() {
    return {
      userInfo: [], // 해당 사용자 정보
      positionList: [], // 직책 DB 정보 리스트
      academicList: [], // 학력 DB 정보 리스트
      itGradeList: [], // 정보통신공사업 DB 정보 리스트
      bankList: [], // 급여은행 DB 정보 리스트
      menuList: [], // 메뉴 DB 정보 리스트
      menuAuthList: [], // 현재 부여된 메뉴 권한 리스트
      menuAuthChgYn: "N", // 메뉴 권한 변경 여부
      userPhotoChgYn: "N", // 사용자 사진 변경 여부
      departmentData: [], // 소속 DB 정보 리스트
      inputData: {
        userId: "",
        userPw: "",
        userName: "",
        selectedGender: "",
        selectedBirthDate: [],
        userSocialNum1: "",
        userSocialNum2: "",
        userCompanyEmail: "",
        userPhone1: "010",
        userPhone2: "",
        userPhone3: "",
        selectedModeAuth: "", // 모드변한 권한
        selectedMenuList: [], // 메뉴 권한
        userNo: "", // 사번
        deptId: "", // 소속 ID
        selectedPosition: "", // 직책
        selectedUserStatus: "", // 재직 상태
        selectedBank: "", // 급여은행
        userBankNum: "", // 급여계좌
      },
      alertMsg: {
        userId: "아이디를 입력해주세요.",
        userPw: "비밀번호를 입력해주세요.",
        userName: "이름을 입력해주세요.",
        selectedGender: "성별을 선택해주세요.",
        selectedBirthDate: "생년월일을 입력해주세요.",
        userSocialNum1: "주민번호 앞자리를 입력해주세요.",
        userSocialNum2: "주민번호 뒷자리를 입력해주세요.",
        userCompanyEmail: "사내메일 계정을 입력해주세요.",
        userPhone2: "휴대폰 번호를 입력해주세요.",
        userPhone3: "휴대폰 번호를 입력해주세요.",
        selectedModeAuth: "모드변한 권한을 선택해주세요.",
        selectedMenuList: "메뉴 권한을 선택해주세요.",
        userNo: "사번을 입력해주세요.",
        deptId: "소속을 선택해주세요.",
        selectedPosition: "직책을 선택해주세요.",
        selectedUserStatus: "재직 상태를 선택해주세요.",
        selectedBank: "급여은행을 선택해주세요.",
        userBankNum: "급여계좌를 입력해주세요.",
        successUserEdit: "직원 정보가 성공적으로 수정되었습니다.",
        failUserEdit: "직원 정보 수정 중 오류가 발생했습니다.",
        uploadFilesMaxCount: "첨부파일은 최대 10개까지 선택 가능합니다.",
        uploadFilesDuplicated: "다음 파일은 이미 추가되었습니다.",
        uploadFilesSizeExceeded: "다음 파일은 크기 제한(100MB)을 초과했습니다.",
        invaildExtensions:
          "허용되지 않는 파일 형식입니다. (허용 확장자: jpg, jpeg, png, gif)",
        errorUserPhotoCompress: "이미지 압축 중 오류가 발생했습니다.",
        errorUserPhotoUpload: "직원 이미지 업로드 중 오류가 발생했습니다.",
        errorUserAttachFilesUpload:
          "직원 이미지 업로드 중 오류가 발생했습니다.",
      },
      focusException: [
        "selectedMenuList",
        "deptId",
        "selectedPosition",
        "selectedBank",
      ],
      emailAddr: [
        "naver.com",
        "daum.net",
        "nate.com",
        "hanmail.net",
        "gmail.com",
      ],
      showDeptPopup: false, // 소속 선택 모달의 표시 여부
      showMenu: false, // 메뉴 선택 표시 여부
      isDuplicate: false, // 사용자 ID 중복 여부
      userPermission: "", // 부서권한
      deptName: "", // 소속명
      userZipCode: "", // 우편번호
      userAddr1: "", // 주소1
      userAddr2: "", // 주소2
      userEmail: "", // 개인이메일 계정
      selectedEmailAddr: "", // 개인이메일 도메인주소
      customEmailAddr: "", // 개인이메일 도메인주소(직접입력)
      selectedInDate: "", // 입사일
      selectedOutDate: "", // 퇴사일
      selectedFirstEvalDate: "", // 1차 평가일
      selectedSecondEvalDate: "", // 2차 평가일
      selectedProbEndDate: "", // 수습 종료일
      selectedAcademic: "", // 학력
      selectedItGrade: "", // 정보통신공사업 코드드
      selectedRelatedMajorMatchYn: "", // 관련전공여부
      selectedResearchPosition: "", // 연구직위
      selectedResearchPositionYn: "", // 연구직등록여부
      attachedFileList: [], // 첨부파일 리스트를 저장할 배열
      uploadedFiles: [], // 새로 추가하는 첨부파일
      uploadedUserPhoto: null, // 기존에 업로드된 사진
      userPhoto: null, // 사진
      validExtensions: ["jpg", "jpeg", "png", "gif"], // 허용할 확장자
      originalData: {}, // 기존 데이터
      changeReasons: [], // 변경된 필드별 이유 저장
      showModalForFields: [], // 변경된 필드를 추적하여 모달창을 하나씩 띄우기 위한 배열
      isModalVisible3: false, // 모달창 표시 여부
      currentFieldIndex: 0, // 현재 모달창에서 보여줄 필드 인덱스
    };
  },
  methods: {
    async setMenuSelection() {
      this.menuList.forEach((menu) => {
        menu.checked = this.inputData.selectedMenuList.some(
          (selected) =>
            Number(selected.menuId) === Number(menu.topMenuId) &&
            selected.type === menu.menuType,
        );

        if (Array.isArray(menu.subLeftMenu) && menu.subLeftMenu.length > 0) {
          menu.subLeftMenu.forEach((sub) => {
            sub.checked = this.inputData.selectedMenuList.some(
              (selected) =>
                selected.type === "L" &&
                Number(selected.menuId) === Number(sub.leftMenuId),
            );
          });
        }
      });
    },
    toggleTopMenu(menu) {
      if (Array.isArray(menu.subLeftMenu)) {
        menu.subLeftMenu.forEach((sub) => (sub.checked = menu.checked));
      }
      this.updateSelectedMenus();
    },
    toggleLeftMenu(menu) {
      let allChecked = true;

      menu.subLeftMenu.forEach((sub) => {
        if (!(sub.checked === "true" || sub.checked === true)) {
          allChecked = false;
        }
      });

      menu.checked = allChecked;
      this.updateSelectedMenus();
    },
    selectAllMenus() {
      this.menuList.forEach((menu) => {
        menu.checked = true;
        if (menu.subLeftMenu) {
          menu.subLeftMenu.forEach((sub) => {
            sub.checked = true;
          });
        }
      });
      this.updateSelectedMenus();
    },
    unselectAllMenus() {
      this.menuList.forEach((menu) => {
        menu.checked = false;
        if (menu.subLeftMenu) {
          menu.subLeftMenu.forEach((sub) => {
            sub.checked = false;
          });
        }
      });
      this.updateSelectedMenus();
    },
    updateSelectedMenus() {
      this.inputData.selectedMenuList = [];

      this.menuList.forEach((menu) => {
        if (
          menu.menuName !== "방문객예약" &&
          menu.menuName !== "CS" &&
          menu.menuName !== "보고"
        ) {
          if (Array.isArray(menu.subLeftMenu)) {
            menu.subLeftMenu.forEach((sub) => {
              if (sub.checked === true || sub.checked === "true") {
                this.inputData.selectedMenuList.push({
                  userId: this.inputData.userId,
                  menuId: sub.leftMenuId,
                  type: "L",
                });
                if (
                  !this.inputData.selectedMenuList.some(
                    (item) =>
                      item.menuId === menu.topMenuId && item.type === "T",
                  )
                ) {
                  this.inputData.selectedMenuList.push({
                    userId: this.inputData.userId,
                    menuId: menu.topMenuId,
                    type: "T",
                  });
                }
              }
            });
          }
        } else {
          if (menu.checked === true || menu.checked === "true") {
            this.inputData.selectedMenuList.push({
              userId: this.inputData.userId,
              menuId: menu.topMenuId,
              type: "T",
            });
          }
        }
      });
    },
    goToUserList() {
      this.$router.push({ path: "/employee/list" });
    },
    selectPosition(positionName) {
      this.inputData.selectedPosition = positionName;
    },
    selectAcademic(academicCode) {
      this.selectedAcademic = academicCode;
    },
    selectItGrade(gradeCode) {
      this.selectedItGrade = gradeCode;
    },
    selectBank(bankId) {
      this.inputData.selectedBank = bankId;
    },
    selectUserStatus(status) {
      this.inputData.selectedUserStatus = status;
    },
    selectGender(gender) {
      this.inputData.selectedGender = gender;
    },
    selectRelatedMajorMatchYn(selValue) {
      this.selectedRelatedMajorMatchYn = selValue;
    },
    selectResearchPosition(postionCode) {
      this.selectedResearchPosition = postionCode;
    },
    selectResearchPositionYn(selValue) {
      this.selectedResearchPositionYn = selValue;
    },
    selectModeAuth(mode) {
      this.inputData.selectedModeAuth = mode;
    },
    selectEmailAddr(emailAddr) {
      this.selectedEmailAddr = emailAddr;
    },
    handleSelectDepartment(selectedDepartment) {
      if (
        selectedDepartment.deptName.includes("대표") ||
        selectedDepartment.deptName.includes("임원")
      ) {
        this.userPermission = "A";
      } else if (
        selectedDepartment.deptName.includes("전략영업") ||
        selectedDepartment.deptName.includes("국내영업팀")
      ) {
        this.userPermission = "B";
      } else if (selectedDepartment.deptName.includes("개발팀")) {
        this.userPermission = "D";
      } else if (selectedDepartment.deptName.includes("PM팀")) {
        this.userPermission = "F";
      } else if (selectedDepartment.deptName.includes("경영지원")) {
        this.userPermission = "M";
      } else if (selectedDepartment.deptName.includes("기획팀")) {
        this.userPermission = "P";
      } else if (selectedDepartment.deptName.includes("디자인팀")) {
        this.userPermission = "S";
      } else if (selectedDepartment.deptName.includes("마케팅팀")) {
        this.userPermission = "K";
      } else {
        // 임원
        this.userPermission = "A";
      }
      this.inputData.deptId = selectedDepartment.deptId;
      this.deptName = selectedDepartment.departPath;
      this.showDeptPopup = false;
    },
    setUserPermission(deptName) {
      let userPermission = "";

      if (deptName.includes("전략영업") || deptName.includes("국내영업팀")) {
        userPermission = "B";
      } else if (deptName.includes("개발팀")) {
        userPermission = "D";
      } else if (deptName.includes("PM팀")) {
        userPermission = "F";
      } else if (deptName.includes("경영지원")) {
        userPermission = "M";
      } else if (deptName.includes("기획팀")) {
        userPermission = "P";
      } else if (deptName.includes("디자인팀")) {
        userPermission = "S";
      } else if (deptName.includes("마케팅팀")) {
        userPermission = "K";
      } else {
        // 임원
        userPermission = "A";
      }
      return userPermission;
    },
    checkChanges() {
      this.showModalForFields = [];

      const compareReqFieldsMap = {
        userPw: "패스워드",
        userName: "이름",
        selectedGender: "성별",
        selectedBirthDate: "생년월일",
        userSocialNum: "주민번호",
        userCompanyEmail: "사내메일",
        userPhone: "휴대폰번호",
        selectedModeAuth: "모드변환 권한",
        selectedMenuList: "메뉴 권한",
        userNo: "사번",
        deptId: "소속",
        selectedPosition: "직책",
        selectedUserStatus: "재직 상태",
        selectedBank: "급여은행",
        userBankNum: "급여계좌",
      };

      const compareBasicFieldsMap = {
        userZipCode: "우편번호",
        userAddr1: "주소",
        userAddr2: "상세주소",
        userEmail: "개인메일",
        selectedInDate: "입사일",
        selectedOutDate: "퇴사일",
        selectedFirstEvalDate: "1차평가일",
        selectedSecondEvalDate: "2차평가일",
        selectedProbEndDate: "수습종료일",
        selectedResearchPosition: "연구직위",
        selectedResearchPositionYn: "연구직 등록여부",
        selectedAcademic: "학력",
        userMajorName: "전공명",
        userDegreeName: "학위명",
        userDegreeNo: "학위번호",
        selectedRelatedMajorMatchYn: "관련전공여부",
        selectedItGrade: "정보통신공사업 등급",
        allFiles: "관련자격증 첨부파일",
        userPhoto: "사진",
      };

      const keyMap = {
        userSocialNum: ["userSocialNum1", "userSocialNum2"],
        userPhone: ["userPhone1", "userPhone2", "userPhone3"],
        userZipCode: "userZipcode",
        userBankNum: "bankNum",
        selectedGender: "userGender",
        selectedBirthDate: "userBirth",
        selectedModeAuth: "modeAuthority",
        selectedMenuList: "menuAuthList",
        selectedPosition: "position",
        selectedUserStatus: "userStatus",
        selectedBank: "bankId",
        selectedInDate: "userInDate",
        selectedOutDate: "userOutDate",
        selectedFirstEvalDate: "firstEvalDate",
        selectedSecondEvalDate: "secondEvalDate",
        selectedProbEndDate: "probEndDate",
        selectedResearchPosition: "researchPositionCode",
        selectedResearchPositionYn: "researchPositionYn",
        selectedAcademic: "academicCode",
        userMajorName: "majorName",
        userDegreeName: "degreeName",
        userDegreeNo: "degreeNo",
        selectedRelatedMajorMatchYn: "majorMatchYn",
        selectedItGrade: "itGradeCode",
        uploadedUserPhoto: "userPhoto",
        allFiles: "attachFiles",
      };

      const dashKeys = ["userSocialNum", "userPhone"];
      const emailKeys = ["userEmail", "userCompanyEmail"];

      Object.keys(compareReqFieldsMap).forEach((originalKey) => {
        const inputKey = keyMap[originalKey] || originalKey;
        let originalValue = [];
        let inputValue = [];

        if (dashKeys.includes(originalKey)) {
          originalValue = this.originalData[originalKey];
          inputValue = keyMap[originalKey]
            .map((key) => this.inputData[key])
            .join("-");

          if (originalValue !== inputValue)
            this.showModalForFields.push(compareReqFieldsMap[originalKey]);
        } else if (emailKeys.includes(originalKey)) {
          if (originalKey === "userCompanyEmail") {
            originalValue = this.originalData[originalKey].split("@")[0];
            inputValue = this.inputData[originalKey];
          }

          if (originalValue !== inputValue)
            this.showModalForFields.push(compareReqFieldsMap[originalKey]);
        } else {
          if (this.originalData[inputKey] !== this.inputData[originalKey]) {
            if (originalKey === "selectedMenuList") this.menuAuthChgYn = "Y";
            this.showModalForFields.push(compareReqFieldsMap[originalKey]);
          }
        }
      });

      Object.keys(compareBasicFieldsMap).forEach((originalKey) => {
        const inputKey = keyMap[originalKey] || originalKey;
        let originalValue = [];
        let inputValue = [];

        originalValue = this.originalData[inputKey];

        if (originalKey === "userPhoto")
          inputValue = this[originalKey]?.name ?? "";
        else if (originalKey === "allFiles") {
          originalValue.split(",").sort();
          inputValue = this[originalKey];
          inputValue.sort();
        } else if (emailKeys.includes(originalKey)) {
          if (originalKey === "userEmail") {
            originalValue = this.originalData[originalKey];
            inputValue =
              this.inputData.selectedEmailAddr === "직접입력"
                ? this[originalKey] + "@" + this.customEmailAddr
                : this[originalKey] + "@" + this.selectedEmailAddr;
          }

          if (originalValue !== inputValue)
            this.showModalForFields.push(compareBasicFieldsMap[originalKey]);
        } else inputValue = this[originalKey];

        if (String(originalValue) !== String(inputValue)) {
          if (originalKey === "userPhoto") this.userPhotoChgYn = "Y";
          this.showModalForFields.push(compareBasicFieldsMap[originalKey]);
        }
      });

      /* 직원정보 수정 시, 수정 이유 입력하는 부분 제외요청하여 제외 처리하였음.*/
      // if (this.showModalForFields.length > 0) {
      //   this.isModalVisible3 = true;
      //   this.currentFieldIndex = 0;
      // } else {
      this.editUserInfo();
      //}
    },
    submitChangeReason(reason) {
      const field = this.showModalForFields[this.currentFieldIndex];
      let originval = "";
      let newval = "";

      this.changeReasons.push({
        ItemName: field,
        OriginValue: originval,
        NewValue: newval,
        Reason: reason,
      });

      this.currentFieldIndex++;

      if (this.currentFieldIndex >= this.showModalForFields.length) {
        this.isModalVisible3 = false;
        this.editUserInfo();
      }
    },
    async editUserInfo() {
      if (this.checkFields()) {
        try {
          let userPhotoIsSuccess = true;
          let userAttachFilesIsSuccess = true;

          if (this.userPhotoChgYn === "Y") {
            userPhotoIsSuccess = await this.uploadUserPhoto();

            if (!userPhotoIsSuccess) {
              this.toast.error(this.alertMsg["errorUserPhotoUpload"], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
              });
              return;
            }
          }

          if (this.uploadedFiles.length > 0) {
            userAttachFilesIsSuccess = await this.uploadAttachFiles();

            if (!userAttachFilesIsSuccess) {
              this.toast.error(this.alertMsg["errorUserAttachFilesUpload"], {
                position: "top-center",
                timeout: 1500,
                closeOnClick: true,
                pauseOnHover: true,
                hideProgressBar: true,
                closeButton: false,
              });
              return;
            }
          }

          this.allFiles = [
            this.uploadedFiles.name,
            ...this.attachedFileList,
          ].join(",");

          let formData = new FormData();

          const userObj = {
            UserID: this.inputData.userId, // 사용자ID
            UserPw: this.inputData.userPw, // 패스워드
            UserName: this.inputData.userName, // 사용자명
            UserGender: this.inputData.selectedGender, // 성별
            UserBirth: this.inputData.selectedBirthDate, // 생년월일
            UserSocialNum:
              this.inputData.userSocialNum1 +
              "-" + // 주민번호
              this.inputData.userSocialNum2,
            UserAddr1: this.userAddr1, // 주소1
            UserAddr2: this.userAddr2, // 주소2
            UserZipcode: this.userZipCode, // 우편번호
            UserPermission: this.userPermission, // 부서권한
            UserEmail:
              this.userEmail &&
              (this.selectedEmailAddr === "직접입력"
                ? this.customEmailAddr
                : this.selectedEmailAddr)
                ? this.userEmail +
                  "@" +
                  (this.selectedEmailAddr === "직접입력"
                    ? this.customEmailAddr
                    : this.selectedEmailAddr)
                : "", // 개인메일
            UserCompanyEmail: `${this.inputData.userCompanyEmail}@mizecompany.co.kr`, // 사내메일
            UserPhone: `${this.inputData.userPhone1}-${this.inputData.userPhone2}-${this.inputData.userPhone3}`, // 휴대폰
            ModeAuthority: this.inputData.selectedModeAuth, // 모드변환 권한
            MenuAuthList: this.inputData.selectedMenuList, // 메뉴 권한
            MenuAuthChgYn: this.menuAuthChgYn, // 메뉴 권한 변경 여부
            UserNo: this.inputData.userNo, // 사번
            DeptId: this.inputData.deptId, // 소속
            Position: this.inputData.selectedPosition, // 직책
            UserStatus: this.inputData.selectedUserStatus, // 재직상태
            ResearchPositionCode: this.selectedResearchPosition, // 연구직위
            ResearchPositionYn: this.selectedResearchPositionYn, // 연구직등록여부
            BankId: this.inputData.selectedBank, // 급여은행
            BankNum: this.inputData.userBankNum, // 급여계좌번호
            UserInDate: this.selectedInDate, // 입사일
            UserOutDate: this.selectedOutDate, // 퇴사일
            FirstEvalDate: this.selectedFirstEvalDate, // 1차 평가일
            SecondEvalDate: this.selectedSecondEvalDate, // 2차 평가일
            ProbEndDate: this.selectedProbEndDate, // 수습종료일
            AcademicCode: this.selectedAcademic, // 학력
            MajorName: this.userMajorName, // 전공명
            DegreeName: this.userDegreeName, // 학위명
            DegreeNo: this.userDegreeNo, // 학위번호
            MajorMatchYn: this.selectedRelatedMajorMatchYn, // 관련전공여부
            ItGradeCode: this.selectedItGrade, // 정보통신공사업 등급
            AttachFiles: this.allFiles ? this.allFiles.join(",") : null, // 첨부파일
            UserPhoto: this.userPhoto ? this.userPhoto.name : null, // 사진
            LoginUserId: this.getUserId, // 등록자 ID
          };

          if (!userObj.UserEmail) {
            this.userEmail = "";
            this.selectEmailAddr("");
          }

          formData.append("User", JSON.stringify(userObj));

          const response = await apiClient.post(
            "/api/User/user-edit",
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
          );

          if (response.status === 200) {
            this.toast.success(this.alertMsg["successUserEdit"], {
              position: "top-center", // 메시지 위치
              timeout: 1500, // 3초 동안 표시
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true, // 진행 표시줄 숨기기
              closeButton: false, // X 버튼 숨기기
            });

            await this.getTopMenu(this.$store.state.menuMode);
          }
        } catch (error) {
          console.error("Error editing user data:", error);
          this.toast.error(this.alertMsg["failUserEdit"], {
            position: "top-center",
            timeout: 1500,
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: true,
            closeButton: false,
          });
        }
        eventBus.emit("user-info-updated");
        this.$router.push({ path: this.$route.path });
      }
    },
    async getTopMenu(menuMode = this.$store.state.menuMode) {
      this.$store.commit("setTopMenus", []);

      try {
        const user = {
          LoginUserId: localStorage.getItem("userid"),
          UserType: localStorage.getItem("usertype"),
          MenuMode: menuMode,
        };

        const response = await apiClient.post("/api/Menu/top-menu-list", user);

        if (response.status === 200) {
          this.$store.commit("setTopMenus", JSON.parse(response.data).data);
          this.setSelectedTopMenuByRoute();
          this.getLeftMenu();
        }
      } catch (error) {
        console.error("Error fetching top menu data:", error);
      }
    },
    setSelectedTopMenuByRoute() {
      const currentPath = this.$route.path;
      const matchedMenu = this.$store.state.topMenus.find((menu) => {
        return menu.menuLink && menu.menuLink === currentPath;
      });

      if (matchedMenu) {
        this.$store.commit("setSelectedMenuId", matchedMenu.topMenuId);
      }
    },
    async getLeftMenu() {
      this.$store.commit("setLeftMenus", []);

      try {
        const user = {
          LoginUserId: localStorage.getItem("userid"),
          UserType: localStorage.getItem("usertype"),
          TopMenuId: this.$store.state.selectedMenuId,
          MenuMode: this.$store.state.menuMode,
        };

        const response = await apiClient.post("/api/Menu/left-menu-list", user);

        if (response.status === 200) {
          const originData = JSON.parse(response.data).data;
          const addMyinfoData = {
            id: 0,
            topMenuId: 0,
            leftMenuId: 0,
            menuName: "내 정보 수정",
            menuDomain: "https://mizecloud-partners.co.kr",
            menuLink: "/myinfo/view",
          };
          const addNotiData = {
            id: 0,
            topMenuId: -1,
            leftMenuId: 0,
            menuName: "알림목록",
            menuDomain: "https://mizecloud-partners.co.kr",
            menuLink: "/alarmsnotices/list",
          };

          let mergedData = [
            ...originData,
            addMyinfoData,
            addNotiData,
            ...this.prevLeftMenus,
          ];
          const filteredData = mergedData.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.menuLink === item.menuLink),
          );

          mergedData = filteredData;
          this.$store.commit("setLeftMenus", mergedData);
        }
      } catch (error) {
        console.error("Error fetching left menu data:", error);
      }
    },
    async fetchUserInfoData() {
      try {
        const response = await apiClient.post("/api/User/user-info", {
          UserId: this.id,
        });

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.userInfo = Array.isArray(data.data) ? data.data : [];
          this.originalData = { ...this.userInfo[0] };
          this.inputData.userId = this.userInfo[0].userId;
          this.inputData.userPw = this.userInfo[0].userPw;
          this.inputData.userName = this.userInfo[0].userName;
          this.inputData.selectedGender = this.userInfo[0].userGender;
          this.inputData.selectedBirthDate = this.userInfo[0].userBirth;
          this.inputData.userSocialNum1 =
            this.userInfo[0].userSocialNum.split("-")[0];
          this.inputData.userSocialNum2 =
            this.userInfo[0].userSocialNum.split("-")[1];
          this.userZipCode = this.userInfo[0].userZipcode;
          this.userAddr1 = this.userInfo[0].userAddr1;
          this.userAddr2 = this.userInfo[0].userAddr2;
          this.userEmail = this.userInfo[0].userEmail.split("@")[0];
          let emailDomain = this.userInfo[0].userEmail.split("@")[1];
          if (this.emailAddr.includes(emailDomain))
            this.selectedEmailAddr = emailDomain;
          else {
            this.selectedEmailAddr = "";
            this.customEmailAddr = emailDomain;
          }
          this.inputData.userCompanyEmail =
            this.userInfo[0].userCompanyEmail.split("@")[0];
          this.inputData.userPhone1 = this.userInfo[0].userPhone.split("-")[0];
          this.inputData.userPhone2 = this.userInfo[0].userPhone.split("-")[1];
          this.inputData.userPhone3 = this.userInfo[0].userPhone.split("-")[2];
          this.inputData.selectedModeAuth = this.userInfo[0].modeAuthority;
          this.inputData.selectedMenuList = this.userInfo[0].menuAuthList;
          this.menuAuthList = this.inputData.selectedMenuList || [];
          this.inputData.userNo = this.userInfo[0].userNo;
          this.inputData.deptId = this.userInfo[0].deptId;
          this.deptName = this.userInfo[0].departPath;
          this.userPermission = this.setUserPermission(this.deptName);
          this.inputData.selectedPosition = this.userInfo[0].position;
          this.inputData.selectedUserStatus = this.userInfo[0].userStatus;
          this.inputData.selectedBank = this.userInfo[0].bankId;
          this.inputData.userBankNum = this.userInfo[0].bankNum;
          this.selectedInDate = this.userInfo[0].userInDate;
          this.selectedOutDate = this.userInfo[0].userOutDate;
          this.selectedFirstEvalDate = this.userInfo[0].firstEvalDate;
          this.selectedSecondEvalDate = this.userInfo[0].secondEvalDate;
          this.selectedProbEndDate = this.userInfo[0].probEndDate;
          this.selectedResearchPosition = this.userInfo[0].researchPositionCode;
          this.selectedResearchPositionYn = this.userInfo[0].researchPositionYn;
          this.selectedAcademic = this.userInfo[0].academicCode;
          this.userMajorName = this.userInfo[0].majorName;
          this.userDegreeName = this.userInfo[0].degreeName;
          this.userDegreeNo = this.userInfo[0].degreeNo;
          this.selectedRelatedMajorMatchYn = this.userInfo[0].majorMatchYn;
          this.selectedItGrade = this.userInfo[0].itGradeCode;
          if (this.userInfo[0].attachFiles) {
            this.attachedFileList = this.userInfo[0].attachFiles.split(",");
          }
          if (this.userInfo[0].userPhoto) {
            this.uploadedUserPhoto = this.userInfo[0].userPhoto;
            this.userPhoto = {
              name: this.userInfo[0].userPhoto,
              url: `/employee_img/${encodeURIComponent(
                this.userInfo[0].userPhoto,
              )}`,
            };
          }
          this.$nextTick(() => {
            this.setMenuSelection();
          });
        }
      } catch (error) {
        console.error("Error fetching userInfoList data:", error);
      }
    },
    async fetchPositionData() {
      try {
        const response = await apiClient.post("/api/BaseInfo/postion-info");

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.positionList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching positionList data:", error);
      }
    },
    async fetchAcademicData() {
      try {
        const response = await apiClient.post("/api/BaseInfo/academic-info");

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.academicList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching academicList data:", error);
      }
    },
    async fetchResearchPositionData() {
      try {
        const response = await apiClient.post(
          "/api/BaseInfo/research-position-info",
        );

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.researchPositionList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching researchPositionList data:", error);
      }
    },
    async fetchItGradeData() {
      try {
        const response = await apiClient.post("/api/BaseInfo/it-grade-info");

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.itGradeList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching itGradeList data:", error);
      }
    },
    async fetchBankData() {
      try {
        const response = await apiClient.post("/api/BaseInfo/bank-info");

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.bankList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching bankList data:", error);
      }
    },
    async fetchMenuData() {
      try {
        const response = await apiClient.post("/api/BaseInfo/menu-info");

        if (response.status === 200) {
          const data = JSON.parse(response.data);
          this.menuList = Array.isArray(data.data) ? data.data : [];
        }
      } catch (error) {
        console.error("Error fetching menuList data:", error);
      }
    },
    async fetchDepartmentData() {
      try {
        const response = await apiClient.post("/api/Department/depart-list", {
          UserId: this.getUserId,
        });

        if (response.status === 200) {
          this.departmentData = JSON.parse(response.data);
        }
      } catch (error) {
        console.error("Error fetching department data:", error);
      }
    },
    checkFields() {
      for (const key in this.inputData) {
        if (this.isEmpty(this.inputData[key])) {
          if (
            key === "customEmailAddr" &&
            this.inputData.selectedEmailAddr !== "직접입력"
          ) {
            continue;
          }

          this.toast.error(this.alertMsg[key], {
            position: "top-center", // 메시지 위치
            timeout: 1500, // 3초 동안 표시
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: true, // 진행 표시줄 숨기기
            closeButton: false, // X 버튼 숨기기
          });

          if (this.focusException.includes(key)) {
            if (key === "selectedMenuList") {
              this.$refs.showMenu.focus();
            } else if (key === "deptId") {
              this.$refs.showDeptPopup.focus();
            } else if (key === "selectedPosition") {
              this.$refs.thPosition.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            } else if (key === "selectedBank") {
              this.$refs.thPosition.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          } else {
            this.$refs[key].focus();
          }

          return false;
        }
      }
      return true;
    },
    async uploadUserPhoto() {
      try {
        const formData = new FormData();
        const photo = Array.isArray(this.userPhoto)
          ? this.userPhoto
          : [this.userPhoto];

        for (const image of photo) {
          try {
            // 이미지 압축 옵션 설정
            const options = {
              maxSizeMB: 1, // 이미지 용량 줄이는 설정이며 현재는 1MB (500KB => 0.5 / 250KB => 0.25로 설정하면 되며, 너무 줄일경우 화질 크게 손상되니 적당히 줄일것)
              maxWidthOrHeight: 1024,
              useWebWorker: true,
            };

            const compressedBlob = await imageCompression(image.file, options);
            const compressedFile = new File([compressedBlob], image.file.name, {
              type: image.file.type,
            });

            formData.append(image.name, compressedFile);
          } catch (error) {
            console.error("직원 사진 등록 이미지 압축 오류:", error);
            this.toast.error(this.alertMsg["errorUserPhotoCompress"], {
              position: "top-center",
              timeout: 1500,
              closeOnClick: true,
              pauseOnHover: true,
              hideProgressBar: true,
              closeButton: false,
            });
            return false;
          }
        }

        const response = await apiClient.post(
          "/api/User/user-photo-image-upload",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );

        if (response.status === 200) {
          return true;
        } else return false;
      } catch (error) {
        console.error("직원 사진 등록 이미지 업로드 오류:", error);
        return false;
      }
    },
    async uploadAttachFiles() {
      try {
        const formData = new FormData();

        for (let i = 0; i < this.uploadedFiles.length; i++) {
          formData.append("files", this.uploadedFiles[i]); // 새로 업로드된 파일을 폼 데이터에 추가
        }

        const response = await apiClient.post(
          "/api/User/user-attach-files-upload",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );

        if (response.status === 200) {
          return true;
        } else return false;
      } catch (error) {
        console.error("직원 첨부파일 업로드 오류:", error);
        return false;
      }
    },
    handleFileUpload(event) {
      const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB 제한
      const files = Array.from(event.target.files);

      if (
        this.uploadedFiles.length +
          this.attachedFileList.length +
          files.length >
        10
      ) {
        this.toast.error(this.alertMsg["uploadFilesMaxCount"], {
          position: "top-center",
          timeout: 1500,
          closeOnClick: true,
          pauseOnHover: true,
          hideProgressBar: true,
          closeButton: false,
        });
        return;
      }

      const duplicateFiles = [];
      const oversizedFiles = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const duplicate =
          this.uploadedFiles.some(
            (uploadedFile) => uploadedFile.name === file.name,
          ) ||
          this.attachedFileList.some(
            (attachedFile) => attachedFile === file.name,
          );

        if (file.size > MAX_FILE_SIZE) {
          oversizedFiles.push(file.name);
          continue;
        }

        if (duplicate) {
          duplicateFiles.push(file.name);
        } else {
          this.uploadedFiles.push(file);
        }
      }

      if (duplicateFiles.length > 0) {
        this.toast.error(
          this.alertMsg["uploadFilesDuplicated"] +
            `\r\n\r\n${duplicateFiles.join("\r\n")}`,
          {
            position: "top-center",
            timeout: 1500,
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: true,
            closeButton: false,
          },
        );
      }

      if (oversizedFiles.length > 0) {
        this.toast.error(
          this.alertMsg["uploadFilesSizeExceeded"] +
            `\r\n\r\n${oversizedFiles.join("\r\n")}`,
          {
            position: "top-center",
            timeout: 1500,
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: true,
            closeButton: false,
          },
        );
      }

      event.target.value = "";
    },
    removeFile(index) {
      if (index < this.attachedFileList.length) {
        this.attachedFileList.splice(index, 1); // 기존 첨부파일 리스트에서 삭제
      } else {
        this.uploadedFiles.splice(index - this.attachedFileList.length, 1); // 새로 업로드된 파일 리스트에서 삭제
      }
    },
    async downloadFile(fileName) {
      try {
        const response = await apiClient.get(
          `/api/User/download-file?fileName=${fileName}`,
          { responseType: "blob" },
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("파일 다운로드 중 오류 발생:", error);
      }
    },
    handleImageChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const extension = file.name.split(".").pop().toLowerCase();

      // 파일 확장자가 유효한지 확인
      if (!this.validExtensions.includes(extension)) {
        this.toast.error(
          this.alertMsg["invaildExtensions"] + `\n\n${file.name} `,
          {
            position: "top-center", // 메시지 위치
            timeout: 1500, // 3초 동안 표시
            closeOnClick: true,
            pauseOnHover: true,
            hideProgressBar: true, // 진행 표시줄 숨기기
            closeButton: false, // X 버튼 숨기기
          },
        );

        event.target.value = "";
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.userPhoto = {
          name: file.name,
          url: e.target.result,
          file: file,
        };
      };
      this.userPhotoChgYn = "Y";
      reader.readAsDataURL(file);
    },
    isEmpty(value) {
      return (
        value === "" ||
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0)
      );
    },
    openPostcodePopup() {
      new daum.Postcode({
        oncomplete: (data) => {
          this.userZipCode = data.zonecode;
          this.userAddr1 = data.address;
          this.$refs.userAddr2.focus();
        },
      }).open();
    },
    closeModal() {
      this.isModalVisible3 = false;
    },
  },
  async mounted() {
    this.fetchPositionData();
    this.fetchAcademicData();
    this.fetchResearchPositionData();
    this.fetchItGradeData();
    this.fetchBankData();
    await this.fetchMenuData();
    this.fetchDepartmentData();
    await this.fetchUserInfoData();
  },
};
</script>

<style scoped>
.button-group {
  display: flex;
  gap: 10px;
}

.menu-container {
  display: block;
  width: 100%;
  padding: 15px;
}

.menu-group {
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 15px;
  width: 100%;
}

.menu-header {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.menu-header label {
  display: flex;
  align-items: center;
  gap: 5px;
}

.menu-items {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: 20px;
}

.submenu-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 5px;
  white-space: nowrap;
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.preview-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border: 1px solid #ddd;
}
</style>
